/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { Checkbox, Link, Typography } from '@one-thd/sui-atomic-components';
import {
  setUpdatedShipmentFields,
  useReturnStore,
} from '@src/stores/returnStore';
import { LORPTextOptInTermsDrawer } from './LORPTextOptInTermsDrawer';

export const LORPTextOptIn = () => {
  const [displayTermsDrawer, setDisplayTermsDrawer] = useState(false);
  const returnShipments = useReturnStore((state) => state.returnShipments);
  const pickupShipments =
    returnShipments?.filter((shipment) => shipment.shipmentType === 'PICKUP') ||
    [];
  const pickupShipmentIds = pickupShipments.map(
    (shipment) => shipment.shipmentId,
  );
  const textOptIn = pickupShipments.some(
    (shipment) => shipment.textOptIn === true,
  );

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!pickupShipmentIds.length) {
      return;
    }
    setUpdatedShipmentFields(pickupShipmentIds, {
      textOptIn: event.target.checked,
    });
  };

  if (!pickupShipmentIds.length) {
    return null;
  }

  return (
    <div className="sui-mt-4">
      <div className="sui-grid sui-grid-cols-[auto,1fr] sui-gap-y-1">
        <div className="sui-flex sui-items-center">
          <Checkbox
            id="pickup-text-opt-in"
            checked={textOptIn}
            onChange={handleCheckboxChange}
            inputAttributes={{
              'data-testid': 'pickup-text-opt-in-checkbox',
            }}
          />
        </div>
        <div className="sui-flex sui-items-center">
          <Typography height="tight">
            <label
              htmlFor="pickup-text-opt-in"
              className="sui-text-base sui-leading-5 sui-cursor-pointer"
            >
              Text me updates on the status of my order
            </label>
          </Typography>
        </div>
        <div className="sui-col-start-2">
          <Typography variant="body-xs">
            By checking the box, you consent to The Home Depot and its
            authorized vendors contacting you at the number provided.{` `}
            <Link variant="body-xs" onClick={() => setDisplayTermsDrawer(true)}>
              View Details
            </Link>
          </Typography>
        </div>
      </div>
      <LORPTextOptInTermsDrawer
        open={displayTermsDrawer}
        onClose={() => setDisplayTermsDrawer(false)}
      />
    </div>
  );
};
